export  function featuredSlider() {
    $(".featured-slider").each(function (index, slide) {
		
        let swiperOptions = {
            watchOverflow: true,
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            spaceBetween: 10,
            slidesPerView: 1,
            // centeredSlides: true,
            // freeMode: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
            }
        };

        let swiper = new Swiper(slide, swiperOptions);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuredSlider.js